import { TableProps as AntdTableProps } from 'antd';
import { StyledTable } from './TableStyles';
import { AnyObject } from 'antd/es/_util/type';
import { LoadingOutlined } from '@ant-design/icons';
import EmptyDataThumbnail from '../EmptyDataThumbnail/EmptyDataThumbnail';
import { COLORS } from '@/theme';
import { useTranslation } from 'react-i18next';

export type TableProps<A> = AntdTableProps<A> & {
  loading?: boolean;
};

const antIcon = <LoadingOutlined spin style={{ fontSize: 60, color: COLORS.YELLOW_PRIMARY }} />;

const Table = <A extends AnyObject>({ loading = false, pagination = false, ...props }: TableProps<A>) => {
  const { t } = useTranslation(['common']);

  return (
    <StyledTable
      loading={{
        spinning: loading,
        indicator: antIcon,
      }}
      bordered
      pagination={pagination}
      locale={{
        emptyText: <EmptyDataThumbnail message={t('no_data_message')} />,
      }}
      {...props}
    />
  );
};

export default Table;
